<template>
  <div class="origin-data-page" :class="fullHeight ? 'full-height' : ''" ref="originDataPage">
    <div class="container">
      <div class="data-content">
        <template v-if="showFilter || showPagination">
          <div class="header-content">
            <div>
              <div class="title" v-show="showFilter">
                <i class="iconfont iconshaixuan"></i>
                <span>筛选条件</span>
              </div>
            </div>
            <div class="page-content" v-if="showPagination">
              <el-pagination
                class="pagination"
                @size-change="sizeChangeHandle"
                @current-change="pageChangeHandle"
                :page-sizes="[20, 40, 60, 80, 100]"
                :current-page="page"
                :page-size="size"
                :total="total"
                layout="jumper, prev, next"
              />
              <span>共{{ total.toLocaleString() }}个</span>
              <span v-if="caseTotal && caseTotal !== total">
                <span> / 案件共</span>
                <span>{{ caseTotal.toLocaleString() }}个</span>
              </span>
            </div>
          </div>
          <div class="filter-value" v-if="showFilter">
            <!-- <filter-tips
              :courseId="courseId"
              :instrumentType="instrumentType"
              :courseConditionArr="courseConditionArr"
              :courseFilterArr="courseFilterArr"
              :courseSortInfo="courseSortInfo"
              :researchFilterArr="filterArr"
              :researchSortInfo="researchSortInfo"
              @updFilter="filterItem => showFilterHandle({ filterItem })"
              @delFilter="params => delFieldFilterHandle(params.index)"
              @delSort="params => delSortHandle(params)"
            >
              <div slot="btn" class="add-filter-btn" @click="showFilterHandle()">
                <i class="el-icon-plus"></i>
                <span>添加筛选</span>
              </div>
            </filter-tips> -->
          </div>
        </template>

        <div class="table-content" :class="showNoviceTipIndex !== -1 ? 'show-novice-tip' : ''">
          <el-table
            ref="tableRefs"
            border
            :data="hitsTemp"
            :row-class-name="params => getRowClassHandle(params, highRowId)"
            :header-cell-class-name="getHeaderCellClass"
            @row-click="tapRowHandle"
            v-bind="fullHeight ? { height: '100%' } : {}"
          >
            <el-table-column label="序号" type="index" width="60" align="center">
              <el-tooltip
                slot-scope="scope"
                effect="dark"
                content="导入案件"
                :disabled="!scope.row.isUpload"
                placement="top"
              >
                <div>
                  <div class="upload-tag-icon" v-if="scope.row.isUpload"></div>
                  <span>{{ scope.row.indexNum }}</span>
                </div>
              </el-tooltip>
            </el-table-column>
            <template v-for="(columnItem, columnIndex) in caseColumnsTemp">
              <el-table-column
                :key="columnItem.idAndIndex"
                :resizable="showNoviceTipIndex === -1"
                :width="{ columnItem, columnIndex } | widthFilter(caseColumnsTemp)"
                :min-width="{ columnItem, columnIndex, isMin: true } | widthFilter(caseColumnsTemp)"
                v-if="!hideFieldIds.includes(columnItem.columnKey)"
              >
                <template slot="header">
                  <table-header-tool
                    :actions="toolActionsFilter(toolActions, columnItem)"
                    :title="columnItem.title"
                    :tip-text="columnItem.full_name"
                    :show-novice-tip="showNoviceTipIndex === columnIndex"
                    @noviceFinish="showNoviceTipIndex = -1"
                    @toolHandle="action => toolHandle(action, columnItem)"
                  />
                </template>
                <template slot-scope="scope">
                  <div
                    class="content-text could-tap single-ellipsis"
                    :class="columnItem.isCalculator ? 'is-calculator-text' : ''"
                  >
                  <el-tooltip
                    :content="fetchContent(scope, columnItem, transformDate)"
                    placement="top"
                    :enterable="true"
                    :delay="{ show: 500, hide: 500 }"
                    effect="dark"
                  >
                    <span>{{ fetchContent(scope, columnItem, transformDate) }}</span>
                  </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 筛选器 -->
    <field-filter
      v-if="fieldFilter.show"
      :filterUnitGroupName="filterUnitGroupName"
      :show.sync="fieldFilter.show"
      :all-columns="tableColumns"
      :filter-item="fieldFilter.filterItem"
      :courseId="courseId"
      :courseFilterArr="courseFilterArr"
      :filterArr="filterArr"
      @confirm="confirmFieldFilterHandle"
    />

    <article-modal
      v-if="articleModal.show"
      :show.sync="articleModal.show"
      :courseId="courseId"
      :rowDetail="articleModal.rowDetail"
      :currentRuleArr="articleModal.currentRuleArr"
    />
  </div>
</template>

<script>
import TableHeaderTool from '@/components/tableHeaderTool';
import FieldFilter from '@/components/fieldFilter';
import articleModal from '@/components/articleModal';

import { paragraphRegexpAll, caseNumber, caseBaseTitle, sysCaseWays } from '@/constant';
import dayjs from 'dayjs';
import { services } from '@/service';
import { uniqBy } from 'lodash';

export default {
  components: { TableHeaderTool, FieldFilter, articleModal },
  data() {
    return {
      fieldFilter: {
        show: false,
        filterItem: null
      },
      show: false,
      articleModal: {
        show: false,
        rowDetail: null,
        currentRuleArr: []
      },
      showNoviceTipIndex: -1,
      detailPromiseInfo: {
        id: '',
        promise: null
      }
    };
  },
  props: {
    byCourse: {
      type: Boolean,
      default: false
    },
    hits: {
      type: Array,
      default: () => []
    },
    showFilter: {
      type: Boolean,
      default: true
    },
    instrumentType: {
      type: String,
      default: ''
    },
    courseSortInfo: {
      type: Object,
      default: () => ({})
    },
    researchSortInfo: {
      type: Object,
      default: () => ({})
    },
    courseId: {
      type: String,
      default: ''
    },
    courseFilterArr: {
      type: Array,
      default: () => []
    },
    filterArr: {
      type: Array,
      default: () => []
    },
    tableColumns: {
      type: Array,
      default: () => []
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    total: {
      type: Number,
      default: 0
    },
    caseTotal: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 20
    },
    toolActions: {
      type: Object,
      default: () => ({})
    },
    courseCondition: {
      type: String,
      default: ''
    },
    highRowId: {
      type: String,
      default: ''
    },
    hideFieldIds: {
      type: Array,
      default: () => []
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    byCleaner: {
      type: Boolean,
      default: false
    },
    transformDate: {
      type: Boolean,
      default: false
    },
    unitGroup: {
      type: Object,
      default: () => null
    },
    filterUnitGroupName: {
      type: String,
      default: ''
    },
    currentRecommend: {
      type: Object,
      default: () => null
    },
    tapRowAction: {
      type: String,
      default: ''
    }
  },
  filters: {
    widthFilter({ columnItem, columnIndex, isMin }, caseColumnsTemp) {
      if (!isMin && columnIndex === caseColumnsTemp.length - 1) {
        return '-';
      }
      const widthEnum = { text: '200', num: '100', date: '100' };
      return widthEnum[columnItem.type] || '-';
    }
  },
  computed: {
    hitsTemp() {
      let count = 0;
      const hits = this.hits;
      return hits.map((item, index) => {
        const baseIndexNum = (this.page - 1) * this.size + 1;
        const prevItem = hits[index - 1];
        if (prevItem && prevItem.caseId === item.caseId) {
          count++;
        }
        const rowClassName = (baseIndexNum + index - count) % 2 ? '' : 'stripe-row';
        return { ...item, indexNum: baseIndexNum + index, rowClassName };
      });
    },
    isCaseUnitGroup() {
      return !this.unitGroup || this.unitGroup.id === 'case';
    },
    caseColumnsTemp() {
      let arr = this.tableColumns;

      const defaultFirstColumn = sysCaseWays.includes(this.instrumentType) ? { ...caseNumber } : { ...caseBaseTitle };

      if (this.currentRecommend) {
        arr = [defaultFirstColumn, this.currentRecommend];
      } else if (!this.isCaseUnitGroup) {
        const groupFields = this.unitGroup.fields.map(fieldDetail => {
          return { ...fieldDetail, isUnitCell: true };
        });

        arr = uniqBy([defaultFirstColumn, ...groupFields, ...arr], 'field_name');
      }

      return arr.map((item, index) => {
        return { ...item, idAndIndex: `${item._id}_${item.title}_${index}` };
      });
    },
    courseConditionArr() {
      return (this.courseCondition && JSON.parse(this.courseCondition)) || [];
    }
  },
  mounted() {},
  methods: {
    fetchContent(scope, columnItem, transformDate) {
      const dataByColumn = scope.row[columnItem.columnKey] || '';
      if (columnItem.type === 'text') {
        return dataByColumn.replace(paragraphRegexpAll, '');
      } else if (columnItem.type === 'date' && transformDate) {
        if (!dataByColumn) {
          return '';
        }
        return dayjs(dataByColumn).format('YYYY-MM-DD');
      } else if (columnItem.type === 'num' && !isNaN(dataByColumn)) {
        return dataByColumn.toLocaleString();
      } else {
        return dataByColumn || '';
      }
    },
    columnMergeHandle({ row, rowIndex, columnIndex }) {
      if (this.isCaseUnitGroup || columnIndex !== 0) {
        return { rowspan: 1, colspan: 1 };
      }

      const hitsTemp = this.hitsTemp;

      const preItem = hitsTemp[rowIndex - 1];
      if (preItem && preItem.caseId === row.caseId) {
        return { rowspan: 1, colspan: 0 };
      }

      let nextCount = 0;
      const laseArr = hitsTemp.slice(rowIndex + 1);
      for (let i = 0; i < laseArr.length; i++) {
        const item = laseArr[i];
        if (item && item.caseId === row.caseId) {
          nextCount++;
        } else {
          break;
        }
      }

      if (nextCount === 0) {
        return { rowspan: 1, colspan: 1 };
      }

      return { rowspan: nextCount + 1, colspan: 1 };
    },
    scrollToTopHandle() {
      const overflowY = this.$el.getElementsByClassName('el-table__body-wrapper')[0];
      if (!overflowY) {
        return;
      }
      overflowY.scrollTop = 0;
    },
    initNoviceHandle() {
      const isVisited = localStorage.getItem('originData_visited');
      if (!isVisited) {
        this.showNoviceTipIndex = 0;
        localStorage.setItem('originData_visited', 1);
      }
    },
    tapRowHandle(row) {
      if (this.tapRowAction === 'article') {
        this.showArticleModal(row);
      } else {
        this.$emit('tapRow', row);
      }
    },
    async showArticleModal(row) {
      if (row.para_content) {
        this.articleModal = {
          show: true,
          rowDetail: row,
          currentRuleArr: this.caseColumnsTemp
        };
        return;
      }

      if (this.detailPromiseInfo.id !== row.caseId) {
        this.detailPromiseInfo.id = row.caseId;
        this.detailPromiseInfo.promise = null;
      }

      const msgEl = this.$message({ message: '全文加载中...', duration: 0 });
      try {
        if (!this.detailPromiseInfo.promise) {
          this.detailPromiseInfo.promise = services.originCase.getCaseDetail(this.detailPromiseInfo.id);
        }
        const { hits } = await this.detailPromiseInfo.promise;
        if (!hits[0]) {
          throw new Error('案件查询失败，无法查看全文');
        }
        this.articleModal = {
          show: true,
          text: hits[0],
          currentRuleArr: this.caseColumnsTemp
        };
      } catch (err) {
        this.$error(err);
      } finally {
        msgEl.close();
      }
    },
    toolHandle(action, headerItem = null) {
      const fieldDetail = headerItem ? this.caseColumnsTemp.find(item => item._id === headerItem._id) : null;
      if (action === 'filter') {
        // 只有filter需要特殊处理，在组件内筛选完后再抛出changeFilter事件
        const currentFilterArr = [...this[this.byCourse ? 'courseFilterArr' : 'filterArr']];
        const filterItem = currentFilterArr.find(item => {
          if (item.columnInfo) {
            return item.columnInfo.columnKey === headerItem.columnKey;
          }
          return false;
        });
        this.showFilterHandle({ filterItem: filterItem ? filterItem : { columnInfo: fieldDetail } });
      } else {
        this.$emit(action, { headerItem: fieldDetail });
      }
    },
    async showFilterHandle(params) {
      const { filterItem = null } = params || {};
      this.fieldFilter = {
        show: true,
        filterItem
      };
    },
    async confirmFieldFilterHandle(filterData) {
      const currentFilterArr = [...this[this.byCourse ? 'courseFilterArr' : 'filterArr']];
      const newFilterData = { byCleaner: this.byCleaner, ...filterData };
      if (filterData.fieldType === 'group') {
        this.$emit('changeFilter', [newFilterData, ...currentFilterArr]);
        return;
      }

      const index = currentFilterArr.findIndex(item => {
        if (item.isTextFilter || item.isLabelFilter) {
          return false;
        }
        return item.columnInfo && item.columnInfo.columnKey === filterData.columnInfo.columnKey;
      });
      if (index !== -1) {
        currentFilterArr.splice(index, 1);
      }
      this.$emit('changeFilter', [newFilterData, ...currentFilterArr]);
    },
    delSortHandle(sortInfo) {
      this.$emit('delSortInfo', sortInfo);
    },
    delFieldFilterHandle(index) {
      const filterArr = [...this[this.byCourse ? 'courseFilterArr' : 'filterArr']];
      filterArr.splice(index, 1);
      this.$emit('changeFilter', filterArr);
    },
    pageChangeHandle(page) {
      this.$emit('update:page', page);
      this.$emit('changePageInfo', { page, size: this.size });
    },
    sizeChangeHandle(size) {
      const page = 1;
      this.$emit('update:page', page);
      this.$emit('update:size', size);
      this.$emit('changePageInfo', { page, size });
    },
    getRowClassHandle(params, scrollId) {
      if (!scrollId) {
        return '';
      }
      if (params.row.caseId === scrollId) {
        return 'high-row';
      }
      return params.row.rowClassName;
    },
    getHeaderCellClass({ columnIndex }) {
      if (columnIndex === 0) {
        return;
      }
      const index = columnIndex - 1;
      const fieldDetail = this.caseColumnsTemp[index];
      if (fieldDetail.isUnitCell) {
        return 'is-unit-cell';
      }
      return '';
    },
    toolActionsFilter(actions, fieldDetail) {
      const actionInfo = { ...actions };

      Object.keys(actionInfo).forEach(key => {
        const actionItem = actionInfo[key];
        if (actionItem.isUnitCellAction && !fieldDetail.isUnitCell) {
          delete actionInfo[key];
        }
      });

      return actionInfo;
    }
  }
};
</script>

<style lang="scss" scoped>
.origin-data-page {
  box-sizing: border-box;

  &.full-height {
    height: 100%;

    .container {
      height: 100%;

      .data-content {
        height: 100%;
        display: flex;
        flex-direction: column;

        .table-content {
          flex: 1;
          height: 0;
        }
      }
    }
  }

  .container {
    .data-content {
      box-sizing: border-box;
      position: relative;

      .header-content {
        box-sizing: border-box;
        width: 100%;
        padding: 10px 2px 0px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @mixin headerFont {
          font-size: 14px;
          line-height: 24px;
          color: rgba(#2c3443, 0.7);
        }

        .title {
          @include headerFont;
          padding-right: 12px;

          .iconfont {
            position: relative;
            top: 1px;
            margin-right: 5px;
          }
        }

        .page-content {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 14px;
          line-height: 24px;
          color: rgba(44, 52, 67, 0.7);
          padding-right: 10px;
          margin-bottom: 8px;

          ::v-deep .el-pagination {
            @include headerFont;

            .el-pagination__jump {
              @include headerFont;
            }
          }
        }
      }

      .filter-value {
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 5px 20px 0;

        .add-filter-btn {
          display: inline-block;
          height: 24px;
          line-height: 24px;
          font-size: 14px;
          padding: 0 16px;
          background: #ecf5ff;
          color: #409eff;
          cursor: pointer;
          margin: 0 10px 10px 0;
          border-radius: 4px;

          & > i {
            margin-right: 5px;
          }

          & > span {
            font-size: 12px;
          }
        }
      }

      .table-content {
        ::v-deep .stripe-row {
          & > td {
            background-color: #f5f7fa;
          }
        }
        ::v-deep .high-row {
          & > td {
            background-color: #eaf6ff;
          }
        }
        ::v-deep .is-unit-cell {
          background-color: #fff4cb;
        }
        .add-column-icon {
          font-size: 16px;
          cursor: pointer;
          text-align: center;
          color: rgb(64, 158, 255);
        }

        .upload-tag-icon {
          position: absolute;
          top: 0;
          left: 0;
          width: 0px;
          height: 0px;
          border: 10px solid transparent;
          border-right-color: #f7c544;
          transform: rotate(45deg) translate(-16px, -2px);
        }

        .content-text {
          cursor: pointer;

          &.is-calculator-text {
            color: #ffa938;
          }
        }

        ::v-deep .el-table {
          color: rgba(#3d465a, 0.8);
          .el-table__header-wrapper {
            tr > th {
              padding: 0;
              .cell {
                padding-left: 0;
                padding-right: 0;
              }
            }
          }
        }

        &.show-novice-tip {
          ::v-deep .el-table {
            .el-table__header-wrapper {
              overflow: visible;
              tr > th {
                overflow: visible;
              }
              .cell {
                overflow: visible;
              }
            }
          }
        }
      }
    }
  }

  .drag-ul {
    .drag-item {
      font-size: 12px;
      padding: 10px 0;
      color: #454f63;
      cursor: move;

      .icon {
        margin-right: 6px;
      }
    }
  }
}
</style>
